import { useEffect } from "react";
import { type To, useNavigate } from "react-router";

import { useSlug } from "@/hooks/useSlug";

interface Props {
  to: (params: { slug: string }) => To;
  state?: unknown;
}

export function Redirect({ to, state }: Props): null {
  const slug = useSlug();
  const navigate = useNavigate();

  useEffect(() => {
    void navigate(to({ slug }), { state, replace: true });
  }, [navigate, to, slug, state]);

  return null;
}
